import type { MemoIconEnum, Memo as GQLItem } from '../../../generated/api.graphql';

/** A calendar memo — a titled note spanning one or more days. */
export type Memo = {
  id: number;
  title: string;
  description: string | null;
  startDate: string;
  endDate: string;
  icon: MemoIconEnum | null;
  createdByName: string | null;
};

export const fromGql = (item: GQLItem): Memo => ({
  id: item.id,
  title: item.title,
  description: item.description ?? null,
  startDate: item.startDate,
  endDate: item.endDate,
  icon: item.icon ?? null,
  createdByName: item.createdByName ?? null,
});
